export const annualIncome = [
  { value: '0 - 15000', label: '0 - 15000' },
  { value: '15000 - 30000', label: '15000 - 30000' },
  { value: '30000 - 60000', label: '30000 - 60000' },
  { value: '60000 - 80000', label: '60000 - 80000' },
  { value: '80000 - 100000', label: '80000 - 100000' },
  { value: '100000 - 150000', label: '100000 - 150000' },
  { value: '150000 - 250000', label: '150000 - 250000' },
  { value: '250000 - 500000', label: '250000 - 500000' },
  { value: '500000 - 1000000', label: '500000 - 1000000' },
  { value: '1000000 - 2500000', label: '1000000 - 2500000' },
  { value: '2500000 - 5000000', label: '2500000 - 5000000' },
  { value: '5000000 or more', label: '5000000 or more' }
]
